
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCusStockOnHandDialog extends Serenity.EntityDialog<ReportCusStockOnHandRow, any> {
        protected getFormKey() { return ReportCusStockOnHandForm.formKey; }
        protected getIdProperty() { return ReportCusStockOnHandRow.idProperty; }
        protected getLocalTextPrefix() { return ReportCusStockOnHandRow.localTextPrefix; }
        protected getNameProperty() { return ReportCusStockOnHandRow.nameProperty; }
        protected getService() { return ReportCusStockOnHandService.baseUrl; }
        protected getDeletePermission() { return ReportCusStockOnHandRow.deletePermission; }
        protected getInsertPermission() { return ReportCusStockOnHandRow.insertPermission; }
        protected getUpdatePermission() { return ReportCusStockOnHandRow.updatePermission; }

        protected form = new ReportCusStockOnHandForm(this.idPrefix);

    }
}